import Make from './make'

const make = Make('report/')

interface AddRemoteDashboard {
  dashboardName: string
  embedLink: string
}

export const addRemoteDashboard = async (
  data: AddRemoteDashboard,
): Promise<any> => {
  const req = await make.post({
    endpoint: 'add-remote-dashboard',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

export const getRemoteDashboardList = async (): Promise<any> => {
  const req = await make.get({
    endpoint: `list-remote-dashboards`,
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

interface DeleteRemoteDashboard {
  dashboardID: string
}
export const deleteRemoteDashboard = async (
  data: DeleteRemoteDashboard,
): Promise<any> => {
  const req = await make.post({
    endpoint: `delete-remote-dashboard/${data.dashboardID}`,
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

export const updateRemoteDashboard = async (
  data: EmbedItemUpdate,
): Promise<any> => {
  const req = await make.post({
    endpoint: 'update-remote-dashboard',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}
